import PropTypes from "prop-types";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Avatar from "@mui/material/Avatar";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

import backgroundImage from "assets/images/bg-profile.jpeg";

function Header({ name, role, children }) {
  const getInitials = (fullName) => {
    if (!fullName) return "?";
    const parts = fullName.trim().split(" ");
    if (parts.length === 1) return parts[0][0].toUpperCase();
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  };

  return (
    <MDBox position="relative" mb={5}>
      {/* Bannière */}
      <MDBox
        minHeight="16rem"
        borderRadius="xl"
        sx={{
          backgroundImage: `linear-gradient(135deg, rgba(10,52,117,0.82), rgba(24,106,129,0.82)), url(${backgroundImage})`,
          backgroundSize: "cover",
          backgroundPosition: "50% 40%",
        }}
      />

      {/* Carte profil */}
      <Card
        sx={{
          position: "relative",
          mt: -7,
          mx: 3,
          py: 2.5,
          px: 3,
          borderRadius: "14px",
          boxShadow: "0 4px 20px rgba(10,52,117,0.12)",
        }}
      >
        <Grid container spacing={2} alignItems="center">
          <Grid item>
            <Avatar
              sx={{
                width: 72,
                height: 72,
                background: "linear-gradient(135deg, #0A3475, #186A81)",
                fontSize: "1.6rem",
                fontWeight: "bold",
                boxShadow: "0 4px 14px rgba(10,52,117,0.35)",
                border: "3px solid #fff",
              }}
            >
              {getInitials(name)}
            </Avatar>
          </Grid>
          <Grid item xs>
            <MDTypography variant="h5" fontWeight="bold" sx={{ color: "#0A3475", lineHeight: 1.2 }}>
              {name}
            </MDTypography>
            <MDTypography variant="button" sx={{ color: "#186A81", opacity: 0.85 }}>
              {role}
            </MDTypography>
          </Grid>
        </Grid>
        {children}
      </Card>
    </MDBox>
  );
}

Header.defaultProps = {
  name: "Inconnu",
  role: "non spécifié",
  children: "",
};

Header.propTypes = {
  name: PropTypes.node,
  role: PropTypes.node,
  children: PropTypes.node,
};

export default Header;
